(() => {
  const element = document.getElementById('gi-inquiry-product');
  if (!element) return;
  const product = JSON.parse(element.textContent);
  const updateLink = (link) => {
    if (!link) return;
    const url = new URL(link.href, window.location.origin);
    if (url.origin !== window.location.origin || !/\/pages\/(contact|product-help-inquiries)\/?$/.test(url.pathname)) return;
    const form = document.querySelector('product-form:not([data-sticky]) form');
    const id = form?.elements.namedItem('id')?.value || new URL(window.location.href).searchParams.get('variant') || product.selected;
    const variant = product.variants.find(item => String(item.id) === String(id));
    const productUrl = new URL(product.url, window.location.origin);
    if (variant) productUrl.searchParams.set('variant', variant.id);
    url.searchParams.set('product', product.title);
    url.searchParams.set('product_url', productUrl.href);
    url.searchParams.set('quantity', form?.elements.namedItem('quantity')?.value || '1');
    url.searchParams.delete('sku');
    url.searchParams.delete('variant');
    if (variant?.sku) url.searchParams.set('sku', variant.sku);
    if (variant?.title && variant.title !== 'Default Title') url.searchParams.set('variant', variant.title);
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    link.href = url.href;
  };
  const updateLinks = () => document.querySelectorAll('a[href*="/pages/contact"], a[href*="/pages/product-help-inquiries"]').forEach(updateLink);
  updateLinks();
  document.addEventListener('change', updateLinks);
  document.addEventListener('click', event => updateLink(event.target.closest('a[href]')), true);
})();
